const backCameraKeywords: string[] = [
  'rear',
  'back',
  'rück',
  'arrière',
  'trasera',
  'trás',
  'traseira',
  'posteriore',
  '后面',
  '後面',
  '背面',
  '后置', // alternative
  '後置', // alternative
  '背置', // alternative
  'задней',
  'الخلفية',
  '후',
  'arka',
  'achterzijde',
  'หลัง',
  'baksidan',
  'bagside',
  'sau',
  'bak',
  'tylny',
  'takakamera',
  'belakang',
  'אחורית',
  'πίσω',
  'spate',
  'hátsó',
  'zadní',
  'darrere',
  'zadná',
  'задня',
  'stražnja',
  'belakang',
  'बैक',
];

export const findBackCameras = (devices: MediaDeviceInfo[]) => {
  const backCameras: MediaDeviceInfo[] = [];

  devices.forEach((device: MediaDeviceInfo) => {
    for (let i = 0; i < backCameraKeywords.length; i++) {
      const backCameraKeyword = backCameraKeywords[i];
      if (device.label.toLocaleLowerCase().includes(backCameraKeyword)) {
        backCameras.push(device);
        break;
      }
    }
  });

  return backCameras;
};
